import { render, staticRenderFns } from "./common-form.vue?vue&type=template&id=14125ff4&scoped=true"
import script from "./common-form.ts?vue&type=script&lang=ts&external"
export * from "./common-form.ts?vue&type=script&lang=ts&external"
import style0 from "./common-form.less?vue&type=style&index=0&id=14125ff4&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14125ff4",
  null
  
)

export default component.exports